<template>
  <li
      :data-type="node.type.name"
      :data-done="done.toString()"
      class="todo-item">
    <base-checkbox
        v-model="done"
        contenteditable="false">
    </base-checkbox>
    <div ref="content"></div>
  </li>
</template>

<script>
import BaseCheckbox from '@/components/core/BaseCheckbox.vue';

export default {
  components: {
    BaseCheckbox,
  },
  props: {
    node: {
      type: Object,
    },
    updateAttrs: {
      type: Function,
    },
    view: {
      type: Object,
    },
  },
  computed: {
    done: {
      get() {
        return this.node.attrs.done;
      },
      set() {
        this.updateAttrs({
          done: !this.node.attrs.done,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

li.todo-item {
  display: flex;
  margin-left: -1.5rem;

  .base-checkbox {
    padding: 0.375rem 0.4375rem 0.125rem 0.0625rem;
  }
}

</style>
